'use strict';

import angular from 'angular';

import JoinFac from './joinFac';
import ModelFac from './modelFac';
import UpdateFac from './updateFac';
import VideoFac from './videoFac';
import ProducerFac from './producerFac';

export default angular.module('core.factories', [])
  .factory(JoinFac.UID, JoinFac.factory)
  .factory(ModelFac.UID, ModelFac.factory)
  .factory(ProducerFac.UID, ProducerFac.factory)
  .factory(UpdateFac.UID, UpdateFac.factory)
  .factory(VideoFac.UID, VideoFac.factory)
  .name;



// WEBPACK FOOTER //
// ./~/site_core/src/factories/index.js